import React from "react";
import {
  ComponentDetailPageContent,
  ComponentDetailPageStateProvider,
} from "./";
import { RootComponentEditDialogStateProvider } from "../dialog/root-component-edit-dialog";
import { ComponentEditDialogStateProvider } from "../dialog/component-edit-dialog";

export const ComponentDetailPage = () => {
  return (
    <ComponentDetailPageStateProvider>
      <RootComponentEditDialogStateProvider>
        <ComponentEditDialogStateProvider>
          <ComponentDetailPageContent></ComponentDetailPageContent>
        </ComponentEditDialogStateProvider>
      </RootComponentEditDialogStateProvider>
    </ComponentDetailPageStateProvider>
  );
};
